/* Publish by EComposer at 2026-09-29 21:45:49*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-5h4hgdkn5gr"]=  window.__ectimmers["ecom-5h4hgdkn5gr"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-5h4hgdkn5gr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5h4hgdkn5gr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h9qxsfz8u3g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h9qxsfz8u3g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2djuqgbydqs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2djuqgbydqs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c38ya2mdq4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c38ya2mdq4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-puhzre76k3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-puhzre76k3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o8fy8ngsamg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o8fy8ngsamg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mj6a5s32vi9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mj6a5s32vi9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vghifrqiwr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vghifrqiwr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m7ouz9s6k3n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m7ouz9s6k3n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-btuilves1m7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-btuilves1m7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-viqd1zhwlk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-viqd1zhwlk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e88d7qf6vuu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e88d7qf6vuu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0znzfoakh7fa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0znzfoakh7fa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yishk70pc0n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yishk70pc0n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1cy0mvv07pr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1cy0mvv07pr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kxeai3o81bp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kxeai3o81bp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-igikvgh9gv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-igikvgh9gv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yjrmh3c3y8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yjrmh3c3y8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g35ch3ka13s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g35ch3ka13s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ant293l2d3w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ant293l2d3w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mhfkgh0r3sa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mhfkgh0r3sa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a08ayc0prs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a08ayc0prs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zmz0b4j862b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zmz0b4j862b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g6vsnzqt296').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g6vsnzqt296', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4mvzkubxtcw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4mvzkubxtcw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e3ngem9b7ef').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e3ngem9b7ef', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yqbjpgvvy8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yqbjpgvvy8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-69ra5cd1a1d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-69ra5cd1a1d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-13ueqzew93xe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-13ueqzew93xe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u96cx7k5jt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u96cx7k5jt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z2cgd011uun').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z2cgd011uun', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3p0rekefwz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3p0rekefwz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vca4owvde8r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vca4owvde8r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2whlk3spno').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2whlk3spno', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dnxnj5qkrba').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dnxnj5qkrba', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bq05fuuagm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bq05fuuagm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7tvvahoyuwa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7tvvahoyuwa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fwao1as5pi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fwao1as5pi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v6k8eyf8gfp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v6k8eyf8gfp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y7g2x0ekigr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y7g2x0ekigr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2vcdx54fma4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2vcdx54fma4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2407r4ju3rf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2407r4ju3rf', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-e2x6ln52ugu"]=  window.__ectimmers["ecom-e2x6ln52ugu"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-e2x6ln52ugu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e2x6ln52ugu', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xt7bmu92ptr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xt7bmu92ptr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7yz9jgaesiq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7yz9jgaesiq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-txda2jw5cxs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-txda2jw5cxs', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8fjts98qf7a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8fjts98qf7a', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-khm52btldxh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-khm52btldxh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5hu78361hms').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5hu78361hms', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-spds1zyyggd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-spds1zyyggd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rzbniepvmtp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rzbniepvmtp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ol6qwa564wc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ol6qwa564wc', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j18z9wa2vg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j18z9wa2vg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j72ev4zooff').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j72ev4zooff', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6ivhl69um').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6ivhl69um', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yipc7penycn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yipc7penycn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2ozlrqcrun3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2ozlrqcrun3', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pae5xulmxr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pae5xulmxr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mfxlnkiy3is').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mfxlnkiy3is', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vegxzetwoni').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vegxzetwoni', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4mgp5bf9jm7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4mgp5bf9jm7', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ku7cdlm1oe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ku7cdlm1oe', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x0corf04x3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x0corf04x3', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-laiynbj80s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-laiynbj80s', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2xl90dpihuv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2xl90dpihuv', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-domp6oh82s9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-domp6oh82s9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w526jca05ba').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w526jca05ba', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hsxpg4x0vzn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hsxpg4x0vzn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3cf5qyd0zxa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3cf5qyd0zxa', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rghh8hpakca').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rghh8hpakca', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-syuvcmhkyp8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-syuvcmhkyp8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sqw9rdgs9pi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sqw9rdgs9pi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x54bd57609').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x54bd57609', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7rpfjn4wqni').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7rpfjn4wqni', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f5332td85ql').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f5332td85ql', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bol2aj5qu69').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bol2aj5qu69', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xhug0oiz82m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xhug0oiz82m', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rffnp57mrk9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rffnp57mrk9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g2tidgo2mhj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g2tidgo2mhj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ifbt581vs6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ifbt581vs6', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fnv6m3qtu9f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fnv6m3qtu9f', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-42k5dn1yjvx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-42k5dn1yjvx', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ylp8x2n288').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ylp8x2n288', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m4xkeqzcg8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m4xkeqzcg8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uk5z64kgu2f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uk5z64kgu2f', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0ywnnowfklq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0ywnnowfklq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yz1f4oxq9k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yz1f4oxq9k', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ssdyuamx8o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ssdyuamx8o', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9o8tr0iickl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9o8tr0iickl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-piv1an1nctm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-piv1an1nctm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t2izvyn9pcp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t2izvyn9pcp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-geb1fqnljev').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-geb1fqnljev', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-khsyg8n2i4j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-khsyg8n2i4j', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mw4ag8so4vm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mw4ag8so4vm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oolabchf2ra').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oolabchf2ra', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tyh30sqlyy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tyh30sqlyy', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dedqc56dbwo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dedqc56dbwo', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zpouf8m9eki').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zpouf8m9eki', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qmavvtf776').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qmavvtf776', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xuku7hnws3b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xuku7hnws3b', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zwvk3pbrmfp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zwvk3pbrmfp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2w5vu7trwyl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2w5vu7trwyl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nqkaxiex43').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nqkaxiex43', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ut0469nvqg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ut0469nvqg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ouj3yllywu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ouj3yllywu', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jwqpirl4yeq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jwqpirl4yeq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7yzc552nskw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7yzc552nskw', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jncg90l6ty').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jncg90l6ty', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h62t3drqvie').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h62t3drqvie', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0o0tsroh55x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0o0tsroh55x', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oea7bk8vvkn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oea7bk8vvkn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3rz320xn3pd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3rz320xn3pd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lsawh79lz4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lsawh79lz4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hl3x66y4r0c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hl3x66y4r0c', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y1jwyf82rgp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y1jwyf82rgp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zja5cb60u2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zja5cb60u2', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-djwqnjadp1v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-djwqnjadp1v', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-63nem7ff2nr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-63nem7ff2nr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-omvs8abneao').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-omvs8abneao', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nydq5vktd6s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nydq5vktd6s', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i3w9t2dsgof').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i3w9t2dsgof', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1vzcjfdgb9i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1vzcjfdgb9i', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zaj274uhf4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zaj274uhf4', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w65pgajuc6f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w65pgajuc6f', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9eo85jd4bik').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9eo85jd4bik', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7ljbqj2tpy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7ljbqj2tpy', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f4b551azbp4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f4b551azbp4', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1v91zj4saf1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1v91zj4saf1', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t2a1sq0tdrh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t2a1sq0tdrh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-esdckn9kxc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-esdckn9kxc', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9tua12dhr58').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9tua12dhr58', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}